import { HelpPageLink } from '@/help/components/help-page-header';
import { SideBarList } from '@/help/components/help-sidebar-nav';
import {
  MainContentWrapper,
  VerticalBar,
  Wrapper,
} from '@/help/components/help-sidebar-nav-styles';
import { BinaryRenderer } from '@/widgets/components/binary-renderer';
import React from 'react';
import { Nav } from 'rsuite';
import { cssVars } from '@/app/styles';
import styled from 'styled-components';
import {
  COOKIE_POLICY_CONTENT,
  POLICY_CONTENT,
  PRIVACY_POLICY_CONTENT,
  TERMS_POLICY_CONTENT,
} from '../policy-config';

const NavWrapper = styled.div`
  margin-top: 28px;
  margin-left: 110px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  color: ${cssVars.textColors.dark3};

  .rs-nav-item-content:hover,
  .rs-nav-item-content {
    color: ${cssVars.textColors.dark3};
  }

  .rs-nav-item-content {
    padding: 0 0 6px 0;
    margin-right: 26px;

    ::before {
      background-color: ${cssVars.helpNavColors.bg3} !important;
    }
  }

  .rs-nav-item-active {
    color: ${cssVars.textColors.dark3};
  }

  .rs-nav-waterline {
    display: none;
  }
`;

export function PolicyNavTabs(props) {
  return (
    <NavWrapper>
      <Nav
        appearance="subtle"
        activeKey={props.activeTab}
        onSelect={props.onNavClick}
      >
        <Nav.Item
          data-cy="cookie-policy-nav-item"
          eventKey={POLICY_CONTENT.COOKIES}
        >
          {POLICY_CONTENT.COOKIES}
        </Nav.Item>
        <Nav.Item
          data-cy="privacy-policy-nav-item"
          eventKey={POLICY_CONTENT.PRIVACY}
        >
          {POLICY_CONTENT.PRIVACY}
        </Nav.Item>
        <Nav.Item data-cy="terms-nav-item" eventKey={POLICY_CONTENT.TERMS}>
          {POLICY_CONTENT.TERMS}
        </Nav.Item>
      </Nav>
    </NavWrapper>
  );
}

export function PolicySidebar(props) {
  return (
    <Wrapper>
      <VerticalBar>
        {props.showReturnToLoginLink && (
          <HelpPageLink
            content="Return to Login"
            onClick={props.returnOnClick}
          />
        )}
        <MainContentWrapper>
          <BinaryRenderer
            checkpoint={props.activeTab === POLICY_CONTENT.COOKIES}
          >
            <SideBarList
              refs={props.refs}
              contentContainerRef={props.contentContainerRef}
              contentList={COOKIE_POLICY_CONTENT}
              searchValue=""
            />
          </BinaryRenderer>
          <BinaryRenderer
            checkpoint={props.activeTab === POLICY_CONTENT.PRIVACY}
          >
            <SideBarList
              refs={props.refs}
              contentContainerRef={props.contentContainerRef}
              contentList={PRIVACY_POLICY_CONTENT}
              searchValue=""
            />
          </BinaryRenderer>
          <BinaryRenderer checkpoint={props.activeTab === POLICY_CONTENT.TERMS}>
            <SideBarList
              refs={props.refs}
              contentContainerRef={props.contentContainerRef}
              contentList={TERMS_POLICY_CONTENT}
              searchValue=""
            />
          </BinaryRenderer>
        </MainContentWrapper>
      </VerticalBar>
    </Wrapper>
  );
}
